import HeaderCreateButton from 'components/Admin/HeaderCreateButton/HeaderCreateButton';
import Paragraph from 'components/TextComps/Paragraph';
import SectionTitle from 'components/TextComps/SectionTitle';
import './CreateEntryCard.scss';
import { ButtonIntent } from '@trackman/web-shared-components/components/types';

export const CreateEntryCard = ({
  entity,
  intent,
  onClick
}: {
  entity: string;
  onClick: () => void;
  intent?: ButtonIntent;
}) => {
  return (
    <div className='create-entry-card'>
      <div>
        <SectionTitle>
          <>No {entity}s added yet.</>
        </SectionTitle>
        <Paragraph>
          <>No {entity}s have been added yet.</>
        </Paragraph>
        <Paragraph>
          <>Create one to get started</>
        </Paragraph>
      </div>
      <HeaderCreateButton buttonTitle={`Create ${entity}`} onClick={onClick} intent={intent} />
    </div>
  );
};
